import React from 'react';

import stripeIcon from 'images/payment/stripe_powered_icon3.svg';
import mastercardIcon from 'images/payment/mastercard-icon.svg';
import visaIcon from 'images/payment/visa-icon.svg';
import discoverIcon from 'images/payment/discover-icon.png';
import americanExpressIcon from 'images/payment/american-express.svg';

export default function SecurityInfo() {
  return (
    <div className="d-md-flex justify-content-between mt-3">
      <div className="text-center text-md-start">
        <div className="small">Secure Payments</div>
        <img src={stripeIcon} alt="stripe-icon" height="20px" />
      </div>
      <div className="text-center text-md-end">
        <div className="small">Safe and Secure SSL Encrypted</div>
        <div className="d-md-flex justify-content-end gap-2">
          <img src={mastercardIcon} alt="mastercard" height="20px" />
          <img src={visaIcon} alt="visa" height="20px" />
          <img src={discoverIcon} alt="discover" height="20px" />
          <img src={americanExpressIcon} alt="american-express" height="20px" />
        </div>
      </div>
    </div>
  );
}
